import { defineMessages } from 'react-intl'

import { CreatePartnersPaymentSummaryCategoryInput } from 'gql/generated/graphql'

export const paymentSummaryCategoryMessages = defineMessages({
  [CreatePartnersPaymentSummaryCategoryInput.Tag]: {
    id: 'paymentSummary.category.tags',
    defaultMessage: 'Tags'
  },
  [CreatePartnersPaymentSummaryCategoryInput.Breakdown]: {
    id: 'paymentSummary.category.breakdown',
    defaultMessage: 'Breakdown'
  },
  [CreatePartnersPaymentSummaryCategoryInput.Payment]: {
    id: 'paymentSummary.category.payment',
    defaultMessage: 'Payment'
  },
  [CreatePartnersPaymentSummaryCategoryInput.Miscellaneous]: {
    id: 'paymentSummary.category.miscellaneous',
    defaultMessage: 'Miscellaneous'
  },
  [CreatePartnersPaymentSummaryCategoryInput.Calendar]: {
    id: 'paymentSummary.category.calendarImage',
    defaultMessage: 'Calendar Image'
  },
  [CreatePartnersPaymentSummaryCategoryInput.Uber]: {
    id: 'paymentSummary.category.uber',
    defaultMessage: 'Uber'
  }
})

export const FILE_CATEGORIES_LIST = [
  CreatePartnersPaymentSummaryCategoryInput.Tag,
  CreatePartnersPaymentSummaryCategoryInput.Breakdown,
  CreatePartnersPaymentSummaryCategoryInput.Payment,
  CreatePartnersPaymentSummaryCategoryInput.Miscellaneous,
  CreatePartnersPaymentSummaryCategoryInput.Calendar,
  CreatePartnersPaymentSummaryCategoryInput.Uber
]
